import React, { useEffect } from 'react';

import { useApp } from '../AppContext';
import { useCompany } from '../components/features/company/context';
import useDocumentTitle from '../components/features/hooks/useDocumentTitle';
import { usePeople } from '../components/features/people/context';

import Loading from '../components/UI/atoms/Loading';
import Listings from '../components/UI/organisms/Listings';

import PeopleFilter from '../components/UI/features/filters/PeopleFilter';
import { emptyObject } from '../lib/emptyObject';

export default function PeopleListing() {
  const {
    query,
    filters,
    results,
    resultsFolder,
    setFilters,
    searchType,
    handleSearch,
    totalResults,
    removeFilter,
    handlePageSize,
    selectedFilters,
    handlePageNumber,
    handleSearchSorted,
    setFolders,
    togglePeopleFavorite
  } = usePeople();
  const { handleSelectCompany } = useCompany();
  const { isLoading } = useApp();

  useDocumentTitle('Executives Search | TNM Marco Polo');

  useEffect(() => {
    if (Object.keys(filters).length === 0) {
      (async () => {
        setFilters();
        setFolders();
      })();
    }
    // eslint-disable-next-line
  }, [filters]);
  
    useEffect(() => {
        (async () => {
            handleSearch();
        })();
    // eslint-disable-next-line
  }, [searchType]);

  return (
    <div>
      {!emptyObject(filters) && (
        <PeopleFilter />
      )}
      { isLoading ? 
        <Loading />
      :
        <Listings
          sortSelected={query.sorting}
          /*addToPortfolio={handlePortfolioOnSearch}*/
          handleSort={handleSearchSorted}
          results={results}
          /*resultsFolder={resultsFolder}*/
          type='company'
          searchType='people'
          select={handleSelectCompany}
          handlePage={handlePageSize}
          pageSize={query.pageSize}
          filters={selectedFilters}
          handleDelete={removeFilter}
          pageNumber={query.pageNumber}
          handlePageNumber={handlePageNumber}
          totalResults={totalResults}
          toggleFavorite={togglePeopleFavorite}
        />
      }
    </div>
  )
}
